import Loader from 'components/Loader/Loader.component';
import { hideModal } from 'components/Modal/Modal.actions';
import { makeSelectIsModalVisible } from 'components/Modal/Modal.selectors';
import { Redirect } from 'components/Redirect';
import PendingSessionsModal from 'pages/accountManagement/partials/PendingSessionsModal/PendingSessionsModal.component';
import { PendingSessionsModalName } from 'pages/accountManagement/partials/PendingSessionsModal/PendingSessionsModal.config';
import { useDispatch, useSelector } from 'react-redux';
import { usePendingSessionsModal } from 'services/pendingSessions/pendingSession.hooks';

export default function PendingSessionsModalWrapper() {
  const dispatch = useDispatch();

  const { isLoading, hasFailed } = usePendingSessionsModal();

  const isPendingSessionsVisible = useSelector(
    makeSelectIsModalVisible(PendingSessionsModalName),
  );

  if (isPendingSessionsVisible && hasFailed) {
    return <Redirect to={'/oops'} />;
  }

  if (isPendingSessionsVisible && isLoading) {
    return <Loader overlayViewMode="fullscreen" active viewMode="fullSize" />;
  }

  return (
    <PendingSessionsModal
      heading="text.pendingSessions.title"
      i18nHeading
      onClose={() => dispatch(hideModal(PendingSessionsModalName))}
    />
  );
}
